
import React from 'react';
import { formatCurrency } from '../utils/calculator';
import { InfoTooltip } from '../ui/InfoTooltip';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ContributionSummary } from './ContributionSummary';
import { ContributionBreakdown } from './ContributionBreakdown';
import { ProjectionTable } from './ProjectionTable';

interface CalculatorResultsProps {
  results: any;
  formData: any;
}

export function CalculatorResults({ results, formData }: CalculatorResultsProps) {
  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-2xl font-semibold text-grandpal-green mb-2">Your Fair Deal Contribution</h3>
        <p className="text-grandpal-gray mb-4">
          Based on your inputs, here's an estimate of your contribution under the Fair Deal scheme.
        </p>
      </div>

      <Tabs defaultValue="summary" className="w-full">
        <TabsList className="grid grid-cols-3 mb-6">
          <TabsTrigger value="summary">Summary</TabsTrigger>
          <TabsTrigger value="breakdown">Detailed Breakdown</TabsTrigger>
          <TabsTrigger value="projection">5-Year Projection</TabsTrigger>
        </TabsList>
        
        <TabsContent value="summary">
          <ContributionSummary 
            results={results} 
            formData={formData} 
          />
        </TabsContent>
        
        <TabsContent value="breakdown">
          <ContributionBreakdown 
            results={results} 
            formData={formData}
          />
        </TabsContent>
        
        <TabsContent value="projection">
          <ProjectionTable 
            projection={results.yearlyProjection}
            formData={formData}
          />
        </TabsContent>
      </Tabs>

      <div className="bg-blue-50 p-4 rounded-md border border-blue-200">
        <h4 className="text-sm font-semibold text-blue-800 flex items-center gap-2">
          Important Notice
          <InfoTooltip content="This calculator provides an estimate only and does not replace official Fair Deal assessment." />
        </h4>
        <p className="text-sm text-blue-700 mt-1">
          This calculator provides an estimate based on current Fair Deal rules. The actual contribution 
          may vary based on the HSE's official assessment. We recommend seeking professional advice.
        </p>
      </div>
    </div>
  );
}
